var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container__footer"},[_c('label',[_vm._v(" "+_vm._s(_vm.$t('poweredBy'))+" "),_c('img',{attrs:{"src":require("../../assets/treevia-logo.png"),"alt":""}}),_vm._v(" | "+_vm._s(`${_vm.$t('slogan')}. | Smartforest 2.0 | ${_vm.latestVersion}`)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }